// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3IMH5","content":"LayoutSettings_content__86d3C"};